import IconClose from "./close.svg?react";
import commonservice from "@apis/commonservice";
import CommonButton from "@components/CommonButton";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import EmailWithCode, { EmailRef } from "@pages/home/components/EmailWithCode";
import { updateSubmitLoading } from "@store/globalSlice";
import { Modal } from "antd";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

const EmailVertifyModal = ({ onSubmit, open, setOpen }: { onSubmit: Function; open: boolean; setOpen: Function }) => {
  const { submitLoading } = useAppSelector((state) => state.globalReducer);
  const refForm = useRef({} as EmailRef & { captchaRef: { validateCaptchaError(val: unknown): void } });
  const isPricingPage = location.pathname === "/pricing";
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // 查询邮箱号是否存在
  const preconditionFn = async (nextFn: Function) => {
    // 验证手机号是否存在，如果存在直接结束，提示手机号存在
    let hasExist = await checkEmailExistence();
    if ((hasExist as any)?.message) {
      return refForm.current.setEmail({
        validateStatus: "error",
        errorMsg: !isPricingPage
          ? t("The email is linked to another account. You can try another email.")
          : t(
              "The email is linked to another account. You can try another email or log out of the current account, then log in with this entered email to complete the payment. ",
            ),
      });
    }
    nextFn?.();
  };

  const checkEmailExistence = async () => {
    const formData = refForm.current.getFieldsValue();
    return commonservice
      .checkEmailIsExist({
        email: formData?.email || "",
      })
      .catch((err) => {
        return Promise.resolve(err);
      });
  };

  return (
    <div className="Component_EmailVertifyModal">
      <Modal
        className="Component-BasicModal Modal-SubAccountPhoneVertifyModal EmailVertifyModal"
        title={isPricingPage ? t("Please verify your email before payment") : t("Verify")}
        open={open}
        onCancel={() => {
          setOpen(false);
          refForm.current.resetFields();
          refForm.current.setEmail({
            validateStatus: "success",
            errorMsg: "",
          });
          dispatch(updateSubmitLoading(false));
          refForm.current?.captchaRef?.validateCaptchaError("");
        }}
        closeIcon={<IconClose></IconClose>}
        destroyOnHidden={true}
        footer={
          <div className="flex justify-end gap-[12px]">
            <CommonButton
              onClick={() => {
                setOpen(false);
                refForm.current.resetFields();
                refForm.current.setEmail({
                  validateStatus: "success",
                  errorMsg: "",
                });
                dispatch(updateSubmitLoading(false));
                refForm.current?.captchaRef?.validateCaptchaError("");
              }}
            >
              {t("Cancel")}
            </CommonButton>
            <CommonButton
              type="primary"
              loading={submitLoading}
              onClick={async () => {
                // 验证码为空时，禁止提交
                const formData = refForm.current.getFieldsValue();
                if (!formData?.captcha || !formData?.captcha.trim()) {
                  refForm.current?.captchaRef?.validateCaptchaError(t("Please enter verification code"));
                  return;
                }
                dispatch(updateSubmitLoading(true));
                await preconditionFn(async () => {
                  try {
                    await onSubmit(refForm.current.getFieldsValue());
                  } catch (err) {
                    refForm.current.captchaRef.validateCaptchaError((err as any)?.message || err);
                  }
                });
                dispatch(updateSubmitLoading(false));
              }}
            >
              {t("Confirm")}
            </CommonButton>
          </div>
        }
      >
        <div className="p-[16px]">
          <EmailWithCode preconditionFn={preconditionFn} type="verify" ref={refForm} />
        </div>
      </Modal>
    </div>
  );
};

export default EmailVertifyModal;
